import { Button, Head, Link } from "zudoku/components";
import { Typography } from "zudoku/components";

export const StandardIntegration = () => {
  return (
    <section className="">
      <Head>
        <title>Стандартные интеграции</title>
      </Head>
      
      <div className="m-auto max-w-4xl p-8">
        <Typography>
        <h1>Стандартные интеграции</h1>
        <p>
            <ul>
                <li><Link to="/docs/php-sdk">PHP SDK</Link> </li>

                <li><Link to="/docs/module-bitrix">Интеграция Bitrix</Link></li>

                <li><Link to="/docs/интеграция-1с">Интеграция модуля для 1С:Розница</Link></li>

                <li><Link to="/docs/интеграция-passteam">Интеграция Passteam</Link></li>

                <li><Link to="/docs/интеграция-osmi-cards">Интеграция OSMI Cards</Link></li>

                <li><Link to="/docs/интеграция-cardsmobileкошелек">Интеграция Cardsmobile (“Кошелек”)</Link></li>

                <li><Link to="/docs/интеграция-frontol">Интеграция Frontol</Link></li>

                <li><Link to="/docs/интеграция-set-retail">Интеграция Set Retail</Link></li>

                <li><Link to="/docs/интеграция-через-albato">Интеграция Albato</Link></li>

                <li><Link to="/docs/интеграция-iiko">Интеграция iiko</Link></li>

                <li><Link to="/docs/интеграция-rkeeper">Интеграция Rkeeper</Link></li>
            </ul>
        </p>
        </Typography>
      </div>
    </section>
  );
};